import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  patients: [],
  loading: false,
  totalCount: 0,
  search: ''
};
const patientSlice = createSlice({
  name: 'patientSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setPatients(state, action) {
      state.patients = action.payload;
    },
    //set selected service by doctor (inside createAndViewServices)
    setTotalCount(state, action) {
      state.totalCount = action?.payload;
    },
    setSearch(state, action) {
      state.search = action?.payload;
    }
  }
});
export const { setPatients, setTotalCount, setSearch } = patientSlice.actions;
export default patientSlice.reducer;
